export function getImageAltText(imagePath) {
    return imagePath.replace(/\.[^.]+$/, '').replace(/[_-]/g, ' ').replace(/\b\w/g, (char)=>char.toUpperCase());
}
